import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams, Page, Pageable } from '@mctic/ng-core';

@Injectable({
  providedIn: 'root'
})
export class ObrigacaoAssumidaService {

  private readonly endpoint = '/sepin-backend/rest/obrigacoes-assumidas';

  constructor(private readonly http: McticHttpClient) {
  }

  consultar(pageable: Pageable) {
    const parametros = new McticHttpParams();
    parametros.setPageable(pageable);
    return this.http.get<Page<any>>(`${this.endpoint}/query`, {params: parametros.toHttpParams()});
  }

  consultarTotal() {
    return this.http.get<any>(`${this.endpoint}/total`);
  }
}
